import Comissioned from './Comissioned';

export default Comissioned;